
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["fill-current",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.61 10.165c-.316.322-.33.894.007 1.223.337.33.9.322 1.223.008L6 7.236l4.153 4.16a.88.88 0 001.223-.008c.33-.337.337-.893.007-1.223l-4.16-4.16 4.16-4.153A.873.873 0 0011.376.63a.887.887 0 00-1.223-.007L6 4.782 1.84.622C1.518.307.946.292.617.629c-.33.337-.323.9-.008 1.216l4.16 4.16-4.16 4.16z"}})])
          )
        }
      }
    